import { initComponent } from './core/init-component.js'
import { addToCart, reRenderShopifySections } from '../components/src/lib/utils'
import { openCart } from './utils/cart.js'

initComponent('.js-pdp', section => {
  // Product Form Elements
  const variantButtons = section.querySelectorAll('.js-pdp-variant')
  const priceEl = section.querySelector('.js-pdp-variant-price')
  const atcForm = section.querySelector('.js-pdp-atc-form')
  const atcButton = section.querySelector('.js-pdp-atc-add')
  const oosButton = section.querySelector('.js-pdp-atc-oos')
  const atcButtonPrice = section.querySelector('.js-button-atc-secondary')
  const personalizationButton = section.querySelector('.js-pdp-atc-personalisation')
  const quantityMessage = section.querySelector('.js-pdp-quantity-message')
  const promoRoot = section.closest('.shopify-section') || section
  const stickyAtc = document.querySelector('.js-pdp-sticky-atc')
  const stickyAtcButton = stickyAtc?.querySelector('.js-pdp-sticky-atc-add')
  const stickyOosButton = stickyAtc?.querySelector('.js-pdp-sticky-atc-oos')
  const stickyAtcPrice = stickyAtc?.querySelector('.js-button-atc-secondary')
  const stickyPersonalizationButton = stickyAtc?.querySelector('.js-pdp-sticky-atc-personalisation')

  const gallery = document.querySelector('.js-pdp-gallery')
  const gallerySwiper = gallery?.querySelector('.js-pdp-gallery-swiper-mob, .js-pdp-gallery-swiper-dt') ? gallery : null
  const galleryMarkupCache = new Map()
  const galleryRequestCache = new Map()

  const sectionId = section.dataset.id
  const productUrl = window.location.pathname

  const tooltips = section.querySelectorAll('.js-pdp-tooltip')

  let selectedVariantButton = section.querySelector('.js-pdp-variant.pdp-active-variant')
  let selectedVariantId = selectedVariantButton?.dataset.variantId
  let latestGalleryRequestId = 0

  if (gallery?.innerHTML && selectedVariantId) {
    galleryMarkupCache.set(selectedVariantId, gallery.innerHTML)
  }

  function toolTipAction() {
    const isMobile = window.innerWidth < 1024

    const hideTooltip = (trigger, tooltipText) => {
      tooltipText.classList.add('opacity-0', 'pointer-events-none')
      tooltipText.setAttribute('aria-hidden', 'true')
      trigger.setAttribute('aria-expanded', 'false')
    }

    const showTooltip = (trigger, tooltipText, setTooltipPosition) => {
      setTooltipPosition()
      tooltipText.classList.remove('opacity-0', 'pointer-events-none')
      tooltipText.setAttribute('aria-hidden', 'false')
      trigger.setAttribute('aria-expanded', 'true')
    }

    tooltips.forEach(tooltip => {
      const tooltipText = tooltip.querySelector('.tooltip')
      if (!tooltipText) return

      const setTooltipPosition = () => {
        const tooltipHeight = tooltipText.offsetHeight + 15
        tooltipText.style.top = '-' + tooltipHeight + 'px'
      }

      tooltipText.classList.remove('opacity-0', 'pointer-events-none')
      setTooltipPosition()
      hideTooltip(tooltip, tooltipText)

      if (isMobile) {
        tooltip.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()

          tooltips.forEach(t => {
            const otherTooltip = t.querySelector('.tooltip')
            if (otherTooltip && otherTooltip !== tooltipText) {
              hideTooltip(t, otherTooltip)
            }
          })

          const isVisible = !tooltipText.classList.contains('opacity-0')
          if (isVisible) {
            hideTooltip(tooltip, tooltipText)
          } else {
            showTooltip(tooltip, tooltipText, setTooltipPosition)
          }
        })
      } else {
        tooltip.addEventListener('mouseenter', () => {
          showTooltip(tooltip, tooltipText, setTooltipPosition)
        })

        tooltip.addEventListener('mouseleave', () => {
          hideTooltip(tooltip, tooltipText)
        })

        tooltip.addEventListener('focus', () => {
          showTooltip(tooltip, tooltipText, setTooltipPosition)
        })

        tooltip.addEventListener('blur', () => {
          hideTooltip(tooltip, tooltipText)
        })

        tooltip.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            hideTooltip(tooltip, tooltipText)
          }
        })
      }
    })

    if (isMobile) {
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-pdp-tooltip')) {
          tooltips.forEach(tooltip => {
            const tooltipText = tooltip.querySelector('.tooltip')
            if (tooltipText) {
              hideTooltip(tooltip, tooltipText)
            }
          })
        }
      })
    }
  }

  toolTipAction()

  function getPersonalizationMetafields() {
    const scriptTag = document.getElementById('personalizationMetafields')
    if (!scriptTag) return []
    try {
      return JSON.parse(scriptTag.innerHTML)
    } catch (e) {
      console.error('Failed to parse personalizationMetafields:', e)
      return []
    }
  }

  const personalizationMetafields = getPersonalizationMetafields()

  function initializeDefaultVariant() {
    const urlParams = new URLSearchParams(window.location.search)
    const variantIdFromUrl = urlParams.get('variant')

    if (variantIdFromUrl) {
      const variantButton = Array.from(variantButtons).find(
        btn => btn.dataset.variantId === variantIdFromUrl
      )
      if (variantButton) {
        selectVariant(variantButton, false)
        return
      }
    }

    const defaultButton = section.querySelector('.js-pdp-variant[data-custom-default-variant]')
    if (defaultButton) {
      selectVariant(defaultButton, true)
      return
    }

    const activeButton = section.querySelector('.js-pdp-variant.pdp-active-variant')
    if (activeButton) {
      selectVariant(activeButton, true)
    }
  }

  function updatePromoBanner(variantId) {
    const activeVariantId = parseInt(variantId, 10)

    const promoBanner = promoRoot.querySelectorAll('.js-variant-promo')

    promoBanner.forEach((banner) => {
      const isActiveVariantPromo = parseInt(banner.dataset.variantId, 10) === activeVariantId

      if (isActiveVariantPromo) {
        banner.removeAttribute('hidden')
        banner.classList.remove('hidden')
      } else {
        banner.setAttribute('hidden', '')
        banner.classList.add('hidden')
      }
    })
  }

  function getGalleryRequestUrl(variantId) {
    return `${productUrl}?variant=${variantId}&section_id=${sectionId}`
  }

  function getCachedGalleryMarkup(variantId) {
    return galleryMarkupCache.get(String(variantId))
  }

  function cacheGalleryMarkup(variantId, markup) {
    if (!variantId || !markup) return

    galleryMarkupCache.set(String(variantId), markup)
  }

  function destroyGallerySwipers(currentGallery) {
    if (!currentGallery) return

    const swiperContainers = currentGallery.querySelectorAll(
      '.js-pdp-gallery-swiper-mob, .js-pdp-gallery-swiper-dt'
    )

    swiperContainers.forEach(swiperContainer => {
      swiperContainer.swiper?.destroy(true, true)
    })
  }

  async function fetchGalleryMarkup(variantId) {
    const cachedMarkup = getCachedGalleryMarkup(variantId)
    if (cachedMarkup) {
      return cachedMarkup
    }

    const requestKey = String(variantId)
    const inFlightRequest = galleryRequestCache.get(requestKey)
    if (inFlightRequest) {
      return inFlightRequest
    }

    const request = fetch(getGalleryRequestUrl(variantId))
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const newGallery = doc.querySelector('.js-pdp-gallery')
        const markup = newGallery?.innerHTML

        if (markup) {
          cacheGalleryMarkup(variantId, markup)
        }

        return markup
      })
      .finally(() => {
        galleryRequestCache.delete(requestKey)
      })

    galleryRequestCache.set(requestKey, request)

    return request
  }

  function prefetchGalleryMarkup(variantId) {
    if (!variantId || getCachedGalleryMarkup(variantId) || galleryRequestCache.has(String(variantId))) {
      return
    }

    void fetchGalleryMarkup(variantId)
  }

  function scheduleGalleryPrefetch() {
    if (!gallerySwiper) return

    const variantIdsToPrefetch = Array.from(variantButtons)
      .map(button => button.dataset.variantId)
      .filter(variantId => variantId && variantId !== selectedVariantId)

    if (!variantIdsToPrefetch.length) return

    const scheduleTask = window.requestIdleCallback
      ? callback => window.requestIdleCallback(callback, { timeout: 1200 })
      : callback => window.setTimeout(callback, 150)

    scheduleTask(() => {
      variantIdsToPrefetch.forEach(prefetchGalleryMarkup)
    })
  }

  async function updateGalleryForVariant(variantId) {
    const requestId = ++latestGalleryRequestId

    try {
      const newGalleryMarkup = await fetchGalleryMarkup(variantId)

      if (!newGalleryMarkup || requestId !== latestGalleryRequestId) return

      const currentGallery = document.querySelector('.js-pdp-gallery')

      if (currentGallery) {
        destroyGallerySwipers(currentGallery)

        currentGallery.innerHTML = newGalleryMarkup

        const reinitEvent = new CustomEvent('gallery:reinit', { bubbles: true })
        currentGallery.dispatchEvent(reinitEvent)
      }
    } catch (error) {
      console.error('Failed to update gallery:', error)
    }
  }

  function selectVariant(button, updateUrl = true) {
    const previousSelectedVariantId = selectedVariantId

    variantButtons.forEach(b => {
      b.classList.remove('bg-brand-black', 'text-grey-0', '!border-brand-black', 'pdp-active-variant')
    })

    button.classList.add('bg-brand-black', 'text-grey-0', '!border-brand-black', 'pdp-active-variant')

    const price = button.dataset.variantPrice
    const priceNoFormat = button.dataset.variantPriceNoFormat
    const variantId = button.dataset.variantId
    const variantSize = button.dataset.variantSize
    const variantImage = button.dataset.variantImage
    const hasPersonalization = button.dataset.hasPersonalization === 'true'
    const hasBottleEngraving = button.dataset.hasBottleEngraving === 'true'
    const hasMedallionEngraving = button.dataset.hasMedallionEngraving === 'true'
    const engravingMessage = button.dataset.engravingMessage || 'Add Complimentary Engraving'
    const medallionMessage = button.dataset.medallionMessage || 'Add Complimentary Engraving'
    const embossingMessage = button.dataset.embossingMessage || 'Add Complimentary Embossing'
    const hasEmbossing = button.dataset.hasEmbossing === 'true'
    const isOOS = button.dataset.oos === 'true'

    selectedVariantButton = button
    selectedVariantId = variantId
    updatePromoBanner(variantId)

    // Update price
    if (priceEl && price) {
      priceEl.textContent = price
      if (atcButtonPrice) {
        atcButtonPrice.textContent = price
      }
      if (stickyAtcPrice) {
        stickyAtcPrice.textContent = price
      }

      // Update cost per ml
      const pricePerMl = section.querySelector('.js-cost-per-unit')
      if (pricePerMl && variantSize) {
        const priceValue = parseFloat(price.replace(/[^0-9.]/g, ''))
        const sizeValue = parseFloat(variantSize)
        const perMlValue = (priceValue / sizeValue).toFixed(2)
        pricePerMl.textContent = pricePerMl.textContent.replace(/[\d.]+/, perMlValue)
      }
    }

    // Update hidden variant ID input in form
    if (atcForm && variantId) {
      const variantInput = atcForm.querySelector('input[name="id"]')
      if (variantInput) {
        variantInput.value = variantId
      }
    }

    // Update Klarna placement value before refreshing messaging
    const klarnaPlacement = section.querySelector('#pdp-klarna') || document.querySelector('#pdp-klarna')
    if (klarnaPlacement && priceNoFormat) {
      klarnaPlacement.setAttribute('data-purchase-amount', priceNoFormat)
    }

    if (window.Klarna?.OnsiteMessaging?.refresh) {
      window.requestAnimationFrame(() => {
        window.Klarna.OnsiteMessaging.refresh()
      })
    }

    // Update personalisation button
    if (personalizationButton && variantId) {

      // Update button text based on personalisation type
      const buttonTextElement = personalizationButton.querySelector('span')
      if (buttonTextElement) {
        let buttonText = 'Add Personalisation'

        if (hasBottleEngraving && hasMedallionEngraving) {
          buttonText = engravingMessage
        } else if (hasBottleEngraving) {
          buttonText = engravingMessage
        } else if (hasMedallionEngraving) {
          buttonText = medallionMessage
        } else if (hasEmbossing) {
          buttonText = 'Add Embossing'
        }

        buttonTextElement.textContent = buttonText
      }

      if (hasPersonalization && !isOOS) {
        personalizationButton.classList.remove('hidden')
      } else {
        personalizationButton.classList.add('hidden')
      }
    }

    if (stickyPersonalizationButton && variantId) {

      const buttonTextElement = stickyPersonalizationButton.querySelector('span')
      if (buttonTextElement) {
        let buttonText = 'Add Personalisation'

        if (hasBottleEngraving && hasMedallionEngraving) {
          buttonText = engravingMessage
        } else if (hasBottleEngraving) {
          buttonText = engravingMessage
        } else if (hasMedallionEngraving) {
          buttonText = medallionMessage
        } else if (hasEmbossing) {
          buttonText = 'Add Embossing'
        }

        buttonTextElement.textContent = buttonText
      }

      if (hasPersonalization && !isOOS) {
        stickyPersonalizationButton.classList.remove('hidden')
      } else {
        stickyPersonalizationButton.classList.add('hidden')
      }
    }

    // Update ATC/OOS buttons
    if (isOOS) {
      atcButton?.classList.add('hidden')
      oosButton?.classList.remove('hidden')
      quantityMessage?.classList.add('hidden')
      stickyAtcButton?.classList.add('hidden')
      stickyOosButton?.classList.remove('hidden')
    } else {
      atcButton?.classList.remove('hidden')
      oosButton?.classList.add('hidden')
      stickyAtcButton?.classList.remove('hidden')
      stickyOosButton?.classList.add('hidden')
    }

    // Update URL with variant parameter
    if (updateUrl && variantId) {
      const url = new URL(window.location.href)
      url.searchParams.set('variant', variantId)
      window.history.replaceState({}, '', url.toString())
    }

    // Update gallery image if available
    if (variantImage && gallerySwiper && variantId && variantId !== previousSelectedVariantId) {
      updateGalleryForVariant(variantId).then(() => {
        // Re-apply state for the currently selected variant (not the stale closure variable)
        // in case the user switched variants while the gallery was fetching
        const currentButton = selectedVariantButton
        if (!currentButton) return

        updatePromoBanner(currentButton.dataset.variantId)

        const currentHasPersonalization = currentButton.dataset.hasPersonalization === 'true'
        const currentIsOOS = currentButton.dataset.oos === 'true'

        if (personalizationButton) {
          if (currentHasPersonalization && !currentIsOOS) {
            personalizationButton.classList.remove('hidden')
          } else {
            personalizationButton.classList.add('hidden')
          }
        }

        if (stickyPersonalizationButton) {
          if (currentHasPersonalization && !currentIsOOS) {
            stickyPersonalizationButton.classList.remove('hidden')
          } else {
            stickyPersonalizationButton.classList.add('hidden')
          }
        }
      })
    }

    const variantMetafields = personalizationMetafields.find(
      v => v.id === parseInt(variantId, 10)
    )

    const variantData = {
      id: parseInt(variantId, 10),
      price: parseFloat(price.replace(/[^0-9.]/g, '')),
      available: !isOOS,
      title: button?.textContent?.trim() ?? ''
    }

    // Dispatch variant change event for personalisation component
    const variantChangeEvent = new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        variant: variantData,
        metafields: variantMetafields || {},
        variantId,
        price,
        hasPersonalization,
        isOOS,
        variantImage
      }
    })
    window.dispatchEvent(variantChangeEvent)

    section.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: {
        variant: variantData,
        metafields: variantMetafields || {},
        variantId,
        price,
        hasPersonalization,
        isOOS,
        variantImage
      }
    }))
  }

  variantButtons.forEach(button => {
    button.addEventListener('mouseenter', () => {
      prefetchGalleryMarkup(button.dataset.variantId)
    })
    button.addEventListener('click', e => {
      e.preventDefault()
      selectVariant(button, true)
    })
  })

  if (personalizationButton) {
    personalizationButton.addEventListener('click', e => {
      e.preventDefault()
      const personalizeDrawer = document.querySelector('.js-personalize-drawer')
      if (personalizeDrawer) {

        personalizeDrawer.dispatchEvent(
          new CustomEvent('drawer:open', { bubbles: true })
        )
      }
    })
  }

  if(stickyPersonalizationButton) {
    stickyPersonalizationButton.addEventListener('click', e => {
      e.preventDefault()
      const personalizeDrawer = document.querySelector('.js-personalize-drawer')
      if (personalizeDrawer) {
        personalizeDrawer.dispatchEvent(
          new CustomEvent('drawer:open', { bubbles: true })
        )
      }
    })
  }

  initializeDefaultVariant()
  scheduleGalleryPrefetch()

  const variantScrollContainer = section.querySelector('.js-variant-scroll-container')
  const variantWrapper = variantScrollContainer?.parentElement

  function updateVariantFade() {
    if (!variantScrollContainer || !variantWrapper) return

    if (window.innerWidth < 1024) {
      variantWrapper.classList.remove('has-fade')
      return
    }

    const hasOverflow = variantScrollContainer.scrollWidth > variantScrollContainer.clientWidth
    const isScrolledToEnd = variantScrollContainer.scrollLeft + variantScrollContainer.clientWidth >= variantScrollContainer.scrollWidth - 5

    variantWrapper.classList.toggle('has-fade', hasOverflow && !isScrolledToEnd)
  }

  if (variantScrollContainer) {
    variantScrollContainer.addEventListener('scroll', updateVariantFade)
    window.addEventListener('resize', updateVariantFade)
    updateVariantFade()
  }

  atcButton?.addEventListener('click', async e => {
    e.preventDefault()
    const variantId = selectedVariantId || atcButton.getAttribute('data-product-id')
    if (!variantId) return

    atcButton.style.pointerEvents = 'none'
    atcButton.style.opacity = '0.7'

    let properties = {}
    const lineProperties = atcButton.getAttribute('data-line-properties')
    if (lineProperties) {
      try {
        properties = JSON.parse(lineProperties)
      } catch (err) {
        console.warn('Failed to parse line properties JSON', err)
      }
    }

    const payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties
        }
      ]
    }

    try {
      await reRenderShopifySections(await addToCart(payload))
      openCart()
    } catch (error) {
      console.error('Add to cart failed:', error)
    } finally {
      atcButton.style.pointerEvents = ''
      atcButton.style.opacity = ''
    }
  })

  stickyAtcButton?.addEventListener('click', async e => {
    e.preventDefault()
    const variantId = selectedVariantId || stickyAtcButton.getAttribute('data-product-id')
    if (!variantId) return

    stickyAtcButton.style.pointerEvents = 'none'
    stickyAtcButton.style.opacity = '0.7'

    let properties = {}
    const lineProperties = stickyAtcButton.getAttribute('data-line-properties')
    if (lineProperties) {
      try {
        properties = JSON.parse(lineProperties)
      } catch (err) {
        console.warn('Failed to parse line properties JSON', err)
      }
    }

    const payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties
        }
      ]
    }

    try {
      await reRenderShopifySections(await addToCart(payload))
      openCart()
    } catch (error) {
      console.error('Add to cart failed:', error)
    } finally {
      stickyAtcButton.style.pointerEvents = ''
      stickyAtcButton.style.opacity = ''
    }
  })

  oosButton?.addEventListener('click', e => {
    e.preventDefault()

    const modal = section.querySelector('.js-bis-modal')
    if (!modal) return

    modal.classList.remove('hidden')

    const variantNode = section.querySelector('.js-pdp-variant.pdp-active-variant')
    if (!variantNode) return

    const variantId = variantNode.dataset.variantId
    const variantTitle = variantNode.textContent.trim()

    const productTitleEl = section.querySelector('.pdp__title-left .heading-5')
    const productTitle = productTitleEl ? productTitleEl.textContent.trim() : ''
    const productId = section.querySelector('.js-pdp-atc-form')?.dataset.productId

    modal.openModal({
      productId,
      variantId,
      productTitle,
      variantTitle
    })
  })

  stickyOosButton?.addEventListener('click', e => {
    e.preventDefault()

    const modal = section.querySelector('.js-bis-modal')
    if (!modal) return

    modal.classList.remove('hidden')

    const variantNode = section.querySelector('.js-pdp-variant.pdp-active-variant')
    if (!variantNode) return

    const variantId = variantNode.dataset.variantId
    const variantTitle = variantNode.textContent.trim()

    const productTitleEl = section.querySelector('.pdp__title-left .heading-5')
    const productTitle = productTitleEl ? productTitleEl.textContent.trim() : ''
    const productId = section.querySelector('.js-pdp-atc-form')?.dataset.productId

    modal.openModal({
      productId,
      variantId,
      productTitle,
      variantTitle
    })
  })

  return {
    unload() {
      if (variantScrollContainer) {
        variantScrollContainer.removeEventListener('scroll', updateVariantFade)
        window.removeEventListener('resize', updateVariantFade)
      }
    }
  }
})
